// eslint-disable-next-line
import { injectable } from "inversify";

import { IStoreLocation } from "../../models/User";
import { IApiResponse, IHttpService } from "../http-service";

import { rootContainer, TYPE } from '../container/root';

export interface IPhysicalStoreStaffPreselection {
    location_id?: string,
    store_id?: number 
}

export interface ShopListItem {
    id: number;
    name: string;
    store_name?: string;
}

interface IPhysicalStoresResponse {
    stores: ShopListItem[],
    current_store_id: number
}

@injectable()
class PhysicalStoreService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    public async getLocations(id?: number): Promise<IStoreLocation[]> {
        const res = await this.httpService.get<IApiResponse<IStoreLocation[]>>(`/rms-api/physical-store-locations/${id}`);
        return res.payload;
    }

    public async getPhysicalStoreStaffLocationId() {
        const res = await this.httpService.get<IApiResponse<string>>(`/rms-api/physical-store-location-id`);
        return res.payload;
    }

    public async setPhysicalStoreStaffLocationId(storeId: number, locationId: string, locationName:string, rememberSelection: boolean) {
        const res = await this.httpService.post<IApiResponse<string>>(`/rms-api/physical-store-location-id`, {
            'store_id': storeId,
            'physical_location_id': locationId,
            'physical_location_name': locationName,
            'remember_selection': rememberSelection,
        });
        return res.payload;
    }

    public async getPhysicalStoreStaffPreselection() {
        const res = await this.httpService.get<IApiResponse<IPhysicalStoreStaffPreselection>>(`/rms-api/physical-store-staff-preselections`);
        return res.payload;
    }

    public async getStoresList() {
        const res = await this.httpService.get<IApiResponse<IPhysicalStoresResponse>>(`/rms-api/stores-list`);
        return res.payload;
    }
}

export default PhysicalStoreService;
